import { InfoDisclaimerBox } from "@covertree/ui/content/InfoDisclaimerBox";

export function PaymentMethodsStripeUpdateDisclaimer({
  renewalLocator,
}: {
  renewalLocator: string;
}) {
  return (
    <InfoDisclaimerBox mt={2}>
      Updating payment details will trigger a renewal re-issuance and create a
      charge. Renewal ID: {renewalLocator}. Please review all details before
      proceeding.
    </InfoDisclaimerBox>
  );
}
